/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Table_Col_UnitInputs */

const vi_await_table_col_unit = /** @type {(inputs: Await_Table_Col_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐVT`)
};

/**

* @param {Await_Table_Col_UnitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_table_col_unit = /** @type {((inputs?: Await_Table_Col_UnitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Table_Col_UnitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_table_col_unit(inputs)
});